module.exports = __webpack_public_path__ + "static/media/snow.a0c17002.png";